<div class="sequence-details-container p-4">
    <div class="flex justify-content-between">
        <h2 class="sequence-details-title mb-4">Create LinkedIn Sequence</h2>
        <div class="button-container flex justify-content-end gap-3 ">
            <p-button label="Cancel" severity="secondary" (onClick)="onCancel()" class="cancel-button"
                [outlined]="true"></p-button>
            <p-button label="Create Sequence" (onClick)="onCreateSequence()" class="create-button"></p-button>
        </div>
    </div>
    <div class="form-container">
        <!-- Sequence Name Section -->
        <div class="field mb-4">
            <label for="sequenceName" class="field-label mb-2 block font-medium">Sequence Name</label>
            <input id="sequenceName" type="text" pInputText [(ngModel)]="sequenceName" placeholder="Enter sequence name"
                class="w-full p-3 border-1 border-gray-300 border-round" />
        </div>

        <!-- Description Section -->
        <div class="field mb-4">
            <label for="description" class="field-label mb-2 block font-medium">Description (Optional)</label>
            <textarea id="description" pInputTextarea [(ngModel)]="description"
                placeholder="Enter a description for this sequence" rows="3"
                class="w-full p-3 border-1 border-gray-300 border-round resize-none"></textarea>
        </div>
        <div class="field mb-4"> 
            <label for="description" class="field-label mb-2 block font-medium">Campaign Sender</label>
            <p-select [options]="senders" [(ngModel)]="selectedSender" optionLabel="firstName"
                placeholder="Choose who will send this campaign" [showClear]="false" styleClass="w-full sender-select mb-3"
                panelStyleClass="sender-panel">
            
                <!-- Custom selected value template -->
                <ng-template pTemplate="selectedItem" let-selectedSender>
                    <div class="flex align-items-center gap-2" *ngIf="selectedSender">
                        <i class="pi pi-user text-gray-500"></i>
                        <div>
                            <div class="font-medium">{{ selectedSender.firstName }} {{ selectedSender.lastName }}
                            </div>
                            <div class="text-sm text-gray-500">{{ selectedSender.emailAddress }}</div>
                        </div>
                    </div>
                </ng-template>
            
                <!-- Custom select item template -->
                <ng-template pTemplate="item" let-sender>
                    <div class="flex align-items-center gap-2 p-2">
                        <i class="pi pi-user text-gray-500 text-lg"></i>
                        <div>
                            <div class="font-medium text-gray-900"> {{ sender?.firstName }} {{ sender?.lastName }}
                            </div>
                            <div class="text-sm text-gray-500"> {{ sender.emailAddress }}</div>
                        </div>
                    </div>
                </ng-template>
            </p-select>
        </div>

        <div class="grid mb-4">
            <div class="col-12 lg:col-6 pr-3">
                <div class="field">
                    <label for="leadsList" class="field-label mb-2 block font-medium">Select the list of leads you want
                        to reach
                        out to</label>
                    <p-select id="leadsList" [options]="leadsLists" [(ngModel)]="selectedLeadsList" optionLabel="name"
                        placeholder="Select leads list" class="w-full"   (ngModelChange)="onLeadsListChange()">
                    </p-select>
                </div>
            </div>
            <div class="col-12 lg:col-6 pl-3">
                <div class="field">
                    <label for="excludeList" class="field-label mb-2 block font-medium">Select exclude list</label>
                    <p-select id="excludeList" [options]="excludeLists" [(ngModel)]="selectedExcludeList"
                        optionLabel="name" placeholder="Select exclude list" class="w-full">
                    </p-select>
                </div>
            </div>
        </div>

        <!-- Exclude Options Section -->
        <div class="field mb-4">
            <label class="field-label mb-3 block font-medium">Exclude options</label>
            <div class="exclude-options-container">
                <div class="flex align-items-center mb-3">
                    <p-checkbox [(ngModel)]="excludeFromOtherHeyReachCampaign" [binary]="true"
                        inputId="excludeOtherHeyReach">
                    </p-checkbox>
                    <label for="excludeOtherHeyReach" class="ml-2 field-label cursor-pointer">
                        Exclude leads contacted from other HeyReach campaign
                        <i class="pi pi-question-circle ml-1 text-gray-500"
                            pTooltip="Leads that have been contacted in other campaigns will be excluded"
                            tooltipPosition="top">
                        </i>
                    </label>
                </div>
                <div class="flex align-items-center mb-3">
                    <p-checkbox [(ngModel)]="excludeMessagedByOtherSenders" [binary]="true"
                        inputId="excludeOtherSenders">
                    </p-checkbox>
                    <label for="excludeOtherSenders" class="ml-2 field-label cursor-pointer">
                        Exclude leads messaged by other senders
                        <i class="pi pi-question-circle ml-1 text-gray-500"
                            pTooltip="Leads that have been messaged by other senders will be excluded"
                            tooltipPosition="top">
                        </i>
                    </label>
                </div>
                <div class="flex align-items-center mb-3">
                    <p-checkbox [(ngModel)]="excludeContactedBySameSender" [binary]="true" inputId="excludeSameSender">
                    </p-checkbox>
                    <label for="excludeSameSender" class="ml-2 field-label cursor-pointer">
                        Exclude leads contacted by same sender from other HeyReach campaign
                        <i class="pi pi-question-circle ml-1 text-gray-500"
                            pTooltip="Leads that have been contacted by the same sender in other campaigns will be excluded"
                            tooltipPosition="top">
                        </i>
                    </label>
                </div>
            </div>
        </div>

        <!-- Sequence Steps Section -->
        <div class="steps-section mb-4">
            <div class="flex justify-content-between align-items-center mb-3">
                <h3 class="steps-title m-0">Sequence Steps</h3>

            </div>

            <!-- Steps List -->
            <div class="steps-list">
                <div *ngFor="let step of steps; let i = index"
                    class="step-card p-4 mb-3 border-1 border-gray-200 border-round">
                    <!-- Step Header -->
                    <div class="flex justify-content-between align-items-center mb-3">
                        <h4 class="step-title m-0">Step {{ i + 1 }}</h4>
                        <p-button icon="pi pi-trash" severity="danger" [text]="true" (onClick)="removeStep(step.id)"
                            class="delete-step-button" size="small"></p-button>
                    </div>

                    <!-- Step Configuration Row -->
                    <div class="grid mb-3">
                        <!-- Activity Type -->
                        <div class="col-12 lg:col-3 mb-3 lg:mb-0 pr-2">
                            <label class="field-label mb-2 block font-medium">Activity Type</label>
                            <p-select [options]="activityTypes" [(ngModel)]="step.activityType" optionLabel="label"
                                placeholder="Select activity" class="w-full"></p-select>
                        </div>

                        <!-- Template -->
                        <div class="col-12 lg:col-4 mb-3 lg:mb-0 pr-2">
                            <label class="field-label mb-2 block font-medium">Template</label>
                            <p-select [options]="templates" [(ngModel)]="step.template" optionLabel="label"
                                placeholder="Select template" class="w-full"></p-select>
                        </div>

                        <!-- Wait Time -->
                        <div class="col-12 lg:col-2 mb-3 lg:mb-0 mr-8 " style="width: 150px;">
                            <label class="field-label mb-2 block font-medium">Wait</label>
                            <p-inputNumber [(ngModel)]="step.waitDuration" [min]="0" [max]="999"></p-inputNumber>
                        </div>

                        <!-- Time Unit -->
                        <div class="col-12 lg:col-3 mb-3 lg:mb-0 ml-10" style="width: 160px;">
                            <label class="field-label mb-2 block font-medium">Unit</label>
                            <p-select [options]="timeUnits" [(ngModel)]="step.waitUnit" optionLabel="label"></p-select>
                        </div>
                    </div>

                    <!-- A/B Testing Toggle -->
                    <div class="ab-testing-section mb-3">
                        <div class="flex align-items-center gap-2">
                            <p-inputSwitch [(ngModel)]="step.enableABTesting"
                                inputId="abTesting-{{step.id}}"></p-inputSwitch>
                            <label [for]="'abTesting-' + step.id" class="field-label font-medium cursor-pointer">
                                Enable A/B Testing
                            </label>
                        </div>
                    </div>

                    <!-- Variant B Content (shown when A/B testing is enabled) -->
                    <div *ngIf="step.enableABTesting" class="variant-b-section">
                        <label class="field-label mb-2 block font-medium">Variant B Content</label>
                        <textarea pInputTextarea [(ngModel)]="step.variantBContent"
                            placeholder="Enter alternative message content for variant B" rows="3"
                            class="w-full p-3 border-1 border-gray-300 border-round resize-none"></textarea>
                    </div>
                </div>
            </div>
            <div class="flex justify-content-center">

                <button pButton pRipple icon="pi pi-plus" label="Add Another Step" class="p-button-text"
                    (click)="addStep()"></button>
            </div>
        </div>


    </div>
</div>